<template>
  <a-card :bordered='false'>
    <span>
      <a-button type="primary" v-has:wxFansTagAdd="()=>{visible = true;visibleType='add'}">
        <PlusOutlined />
        新建标签
      </a-button>
    </span>
    <div class="s_flex_bian s_bor_cf4f m-t-25 s_bor10 s_over_h">
      <div class="width70 s_br1_cf4f p-b-20">
        <div class="height-50 s_flex_ali p-tb0-lr24">
          <p class="fz-18 s_c333 s_font_b">{{tagIndex=='all' ? '粉丝管理':tagNameTitle}}</p>
          <a-button type="link" v-if='tagIndex !== "all" && tagIndex > 2' v-has:wxFansTagEdit="()=>{visible = true;visibleType='edit';tagName=tagNameTitle}">重命名</a-button>
          <a-button type="link" v-if='tagIndex !== "all" && tagIndex > 2' v-has:wxFansTagDel='delTag'>删除</a-button>
        </div>
        <div>
          <div class="s_bf58 height-50 s_flex_ali p-tb0-lr24">
            <a-checkbox v-model:checked="checkAll" @change="onCheckAllChange">全选</a-checkbox>
            <a-popover v-model:visible="showAllTag" title="打标签" trigger="click" placement="bottom">
              <template #content>
                <tagList :tagList='tagList'  @reload="()=>tagListGet()"  :checkedList="checkedList" :isBatch="is_batch" @close="(e)=>close(e,'all')"></tagList>
              </template>
              <a-button class="m-l-20" type="primary" v-if="checkedList.length>0">打标签</a-button>
            </a-popover>
          </div>
          <div class="">
            <a-spin :spinning="loading">
              <div v-if="fansList.length==0" class='p-50'>
                <a-empty :description="false" />
              </div>
              <a-checkbox-group class="width100" v-model:value="checkedList" @change="onChange">
                <div class="s_flex_bian_c width100 p-t-15 p-b-15 s_bb1_cf4f p-tb0-lr24" v-for='(item,index) in fansList' :key='index'>
                  <div class="s_flex_ali">
                    <a-checkbox :value="item.openid"></a-checkbox>
                    <img class="width-52 height-52 m-l-20 m-r-20" :src="item.headimgurl" alt="">
                    <div>
                      <p class="fz-16 s_c333 ">{{item.nickname}}<span v-if='item.remark'>（{{item.remark}}）</span></p>
                      <div class="s_flex_ali m-t-6">
                        <div class="fansTagListBox" v-if='item.tagid_list.length > 0'>
                          <span class="fansTagList s_c666" v-for='items in item.tagid_list' :key='items'>{{val(items)}}<span class='dh'>，</span></span>
                        </div>
                        <p class="s_c666" v-else>无标签</p>
                        <a-popover v-model:visible="item.showTag" title="打标签" trigger="click" placement="bottom">
                          <template #content>
                            <!-- :isBatch="is_batch" -->
                            <tagList :tagList='tagList' :tagIds="item.tagid_list" :checkedList="[item.openid]" :isBatch="is_batch"
                            @reload="()=>tagListGet()" @close="(e)=>close(e,item)"></tagList>
                          </template>
                          <CaretDownOutlined class="m-l-10 s_c666" />
                        </a-popover>
                      </div>
                    </div>
                  </div>
                  <a-popover v-model:visible="item.remarks" title="修改备注" trigger="click" placement="bottom">
                    <template #content>
                      <a-input class="m-b-20 m-t-10" style="width:240px" v-model:value="item.mark" placeholder="请输入备注" />
                      <div class="clearfix ">
                        <a-button class="m-l-20 fr" type="primary" :loading='iconLoading' v-has:wxFansTagUserRemarks="()=>onSubmit(item)">确认</a-button>
                        <a-button class="fr" type="primary" ghost @click="item.remarks = false;item.mark = item.remark">取消</a-button>
                      </div>
                    </template>
                    <a-button class="m-l-20" type="primary" ghost>修改备注</a-button>
                  </a-popover>
                </div>
              </a-checkbox-group>
            </a-spin>
          </div>
        </div>
        <a-pagination class='p-r-25' :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
      </div>
      <div class="width30">
        <div class="height-50 s_c333 s_flex_center s_shou" :class="tagIndex == 'all' ? 's_font_b s_bf58 fz-16':''" v-has:wxFansTagUser='()=>screen("all")'>全部粉丝（{{allFansNum}}）
        </div>
        <div class="height-40 s_c333 s_flex_center s_shou" :class="tagIndex == item.id ? 's_font_b s_bf58 fz-16':''" v-for='(item,index) in tagList' :key='index' v-has:wxFansTagUser='()=>screen(item)'>{{item.name}}（{{item.count}}）</div>
      </div>
    </div>
  </a-card>
  <a-modal  :keyboard="false" title="新建标签" centered v-model:visible="visible" destroyOnClose @ok="createTag" @cancel='tagName=""' :confirm-loading="confirmLoading">
    <a-input v-model:value="tagName" :maxlength='15' placeholder="请输入新的标签名" />
    <p class="m-t-15 s_c999">（最多15个字）</p>
  </a-modal>
</template>
<script>
import { PlusOutlined, CaretDownOutlined } from '@ant-design/icons-vue';
import { ref, onMounted, inject, reactive, toRefs, computed, watch } from 'vue';
import { message } from 'ant-design-vue';
import {
  getTagList,
  createTags,
  getFansList,
  setFansRemarks,
  setFansTag,
  setFansSaveTags,
  delFansSaveTags,
  getTagUserList,
} from '@/api/public_wx';
import { iscode } from '@/utils/app';
import tagList from './components/tagList.vue';
let defSearch = {
  page: 1,
  limit: 10,
};
export default {
  components: { PlusOutlined, CaretDownOutlined, tagList },
  setup(props) {
    const search = ref({ ...defSearch });
    const state = reactive({
      fansList: [],
      tagList: [],
      tagName: '',
      checkedList: [],
      plainOptions: [],
      listLoading: false,
      total: 1,
      visible: false,
      tagIndex: 'all',
      tagNameTitle: '粉丝管理',
      showAllTag: false,
      tagListObj: {},
      status: true,
      indeterminate: true,
      checkAll: false,
      loading: false,
      allFansNum: 0,
      visibleType: 'add',
      confirmLoading: false,
      iconLoading: false,
      // 
      is_batch:0
    });
    const $router = inject('$router');
    const $Modal = inject('$Modal');
    const _lodash = inject('_lodash');
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 全选
    const onCheckAllChange = (e) => {
      Object.assign(state, {
        checkedList: e.target.checked ? state.plainOptions : [],
      });
      state.is_batch=e.target.checked?1:0
    };
    const onChange = (checkedList) => {
      state.indeterminate =
        !!checkedList.length && checkedList.length < state.plainOptions.length;
      state.checkAll = checkedList.length === state.plainOptions.length;
      //
      state.is_batch = checkedList.length === state.plainOptions.length? 1:0
    };
    // 获取标签列表
    const tagListGet = async () => {
      state.loading = true;
      state.tagList=[]
      let res = await getTagList().then((res) => res.data);
      if (iscode(res)) {
              state.tagList = res.data.tags;
        // 将数组转成对象
        state.tagListObj = state.tagList.reduce((pre, current) => {
          pre[current.id] = current;
          return pre;
        }, {});
      }
      state.loading = false;
    };
    // 获取粉丝列表
    const initData = async (values) => {
      state.loading = true;
      let res = await getFansList(values).then((res) => res.data);
      if (iscode(res)) {
        state.fansList = res.data.data || [];
        state.total = res.data.total;
        state.allFansNum = res.data.total;
        state.checkedList = [];
        state.plainOptions = _lodash.map(state.fansList, 'openid');
        state.fansList.map((item) => {
          item.showTag = false;
          item.mark = item.remark;
        });
      } else {
        message.error(res.msg);
      }
      state.loading = false;
    };
    //指定粉丝标签粉丝
    const screen = async (e) => {
      search.value.page = 1;
      state.tagNameTitle = e.name;
      if (e == 'all') {
        state.tagIndex = e;
        initData(search.value);
      } else {
        state.tagIndex = e.id;
        state.loading = true;
        let res = await getTagUserList({ ...search.value, id: e.id }).then(
          (res) => res.data
        );
        if (iscode(res)) {
          state.fansList = res.data.data || [];
          state.total = res.data.total;
          state.checkedList = [];
          state.plainOptions = _lodash.map(state.fansList, 'openid');
          state.fansList.map((item) => {
            item.showTag = false;
            item.mark = item.remark;
            state.checkAll = false;
          });
        } else {
          message.error(res.msg);
        }
        state.loading = false;
      }
    };
    //删除标签
    const delTag = () => {
      $Modal.confirm({
        centered: true,
        title: '粉丝标签删除',
        content: '删除后该粉丝标签将无法恢复，您确定要删除该粉丝标签吗？',
        onOk: async () => {
          let res = await delFansSaveTags({ id: state.tagIndex }).then(
            (res) => res.data
          );
          if (iscode(res)) {
            message.success(res.msg);
            state.tagIndex = 'all';
            initData(search.value);
            tagListGet();
          } else {
            message.error(res.msg);
          }
        },
      });
    };
    //修改备注
    const onSubmit = async (item) => {
      state.iconLoading = true;
      let res = await setFansRemarks({
        openid: item.openid,
        remarks: item.mark,
      }).then((res) => res.data);
      if (iscode(res, true)) {
        item.remarks = false;
        initData(search.value);
      }

      state.iconLoading = false;
    };
    //新增粉丝标签
    const createTag = async () => {
      state.confirmLoading = true;
      let res;
      if (state.visibleType == 'add') {
        res = await createTags({ title: state.tagName }).then(
          (res) => res.data
        );
      } else {
        res = await setFansSaveTags({
          title: state.tagName,
          id: state.tagIndex,
        }).then((res) => res.data);
      }
      if (iscode(res, true)) {
        state.visible = false;
        if (state.visibleType == 'edit') {
          state.tagNameTitle = state.tagName;
        }
        state.tagName = '';
        tagListGet();
      }
      state.confirmLoading = false;
    };

    //过滤
    const val = computed(() => {
      return function (val) {
        if (!val || !state.tagListObj[val]) return;
        return state.tagListObj[val].name;
      };
    });
    //点击标签打勾
    // const changebox = (val) => {
    //   state.checkedList.push(val);
    //   state.checkedList = [...new Set(Object.values(state.checkedList))];
    // };
    //关闭弹窗
    function close(e, item) {
      if (item == 'all') {
        state.showAllTag = false;
      } else {
        item.showTag = false;
      }
      if (e == 'sub') {
        state.checkedList = [];
        initData(search.value);
        tagListGet();
      }
    }
    //用于完成后关闭全选
    watch(
      () => state.checkedList,
      (newValue, oldValue) => {
        state.checkAll = newValue.length === state.plainOptions.length;
      }
    );

    onMounted(() => {
      // 整理数据用于全选
      state.plainOptions = _lodash.map(state.fansList, 'id');
      initData(search.value);
      tagListGet();
    });

    return {
      ...toRefs(state),
      search,
      pageCurrentChange,
      pageSizeChange,
      onCheckAllChange,
      onChange,
      onSubmit,
      createTag,
      val,
      // changebox,
      tagListGet,
      close,
      screen,
      delTag,
    };
  },
};
</script>
<style lang="less" scoped>
.fansTagListBox .fansTagList:last-child .dh {
  display: none;
}
</style>